import { render, staticRenderFns } from "./showdata2.vue?vue&type=template&id=2ad60eaf&"
import script from "./showdata2.vue?vue&type=script&lang=js&"
export * from "./showdata2.vue?vue&type=script&lang=js&"
import style0 from "./showdata2.vue?vue&type=style&index=0&id=2ad60eaf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports